export default __webpack_public_path__ + "static/media/2.660bcd8c.jpeg";